import { Search, X } from 'lucide-react';

export default function EarningsSearchInput({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <label className="relative mx-auto block w-full max-w-md">
      <span className="sr-only">Search earnings</span>
      <Search
        className="pointer-events-none absolute left-3.5 top-1/2 size-5 -translate-y-1/2 text-slate-500 md:size-[1.35rem]"
        strokeWidth={2.75}
        aria-hidden
      />
      <input
        type="text"
        role="searchbox"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Enter ticker symbol"
        autoComplete="off"
        spellCheck={false}
        className="w-full rounded-full border-2 border-emerald-600 bg-white py-3.5 pl-11 pr-11 text-sm text-slate-900 shadow-[0_1px_2px_rgba(15,23,42,0.04)] placeholder:text-slate-500 outline-none transition-colors focus:border-emerald-700 focus:ring-2 focus:ring-emerald-600/15 md:py-4 md:text-[15px]"
      />
      {value ? (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Clear search"
          className="absolute right-2.5 top-1/2 flex size-8 -translate-y-1/2 items-center justify-center rounded-full text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-emerald-600"
        >
          <X className="size-3.5" strokeWidth={2.5} aria-hidden />
        </button>
      ) : null}
    </label>
  );
}
